module.exports = __webpack_public_path__ + "assets/img/img2.7e747bb6.png";